import RequestHandler from "./RequestHandler";

function PublishedModelsAPI() {
    const basePublishedModelsAPI = "published-models";

    async function getPublishedModels(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            let URL = `${basePublishedModelsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getPublishedProductById(id, productVersionId) {
        try {
            const result = await RequestHandler.get(
                `${basePublishedModelsAPI}/${id}${
                    productVersionId
                        ? `?productVersionId=${productVersionId}`
                        : ""
                }`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function publishBundle(publishBundleData) {
        try {
            const result = await RequestHandler.post(
                `${basePublishedModelsAPI}/bundle`,
                publishBundleData
            );
            return result || false;
        } catch (error) {
            console.log(error);
        }
    }

    async function publishModel(publishModelData) {
        try {
            const result = await RequestHandler.post(
                `${basePublishedModelsAPI}`,
                publishModelData
            );
            return result || false;
        } catch (error) {
            console.log(error);
        }
    }

    async function removePublishedModel(publishedModelId) {
        try {
            const result = await RequestHandler.remove(
                `${basePublishedModelsAPI}/${publishedModelId}`
            );
            return result || false;
        } catch (error) {
            console.log(error);
        }
    }

    return {
        publishModel,
        publishBundle,
        getPublishedModels,
        getPublishedProductById,
        removePublishedModel,
    };
}

export default PublishedModelsAPI();
